import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const perm = [P.COMMERCIAL.BROWSE]

const compareCA = {
  path: '/compareCA',
  component: Layout,
  name: 'CA_commerciaux',
  meta: {
    title: 'CA par chargé de compte', // pour le fil d'Arianne
    permissions: perm,
  },

  // no submenu, because children.length == 1
  children: [
    {
      path: '/compareCA',
      component: () => import('@/views/compareCA/DashCompareCA.vue'),
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: {
        title: 'CA par chargé de compte',
        icon: 'mdi:chart-donut',
        permissions: perm,
      },
    }
  ],
}

export default compareCA
